import {
    getBlocklistAdminPermission, getSessionPrivileges, getUserPrivileges, hasExitLockdownPermission,
} from 'common/services/permissions/commonPermissionService';
import { SearchColumn } from 'common/store/common/search/types';
import { UserPrivileges } from 'common/store/session/constants';
import { isNullOrUndefined } from 'common/util/type/typeUtil';
import searchQueryBuilderService from '../search/searchQueryBuilderService';

export enum ActionTypes {
    EDIT_CONTENT = 'editContent',
    PREVIEW_IN_SPLIT_VIEW = 'previewInSplitView',
    OPEN_QUESTION_TEST_CASES = 'openQuestionTestCases',
}

export enum ActionNames {
    RESET_EDITOR_CONTENT = 'resetEditorContent',
    SAVE_EDITOR_CONTENT = 'saveEditorContent',
    SAVE_AS_TEMPLATE = 'saveItemAsTemplate',
}

const permissionService = {
    hasCurrentUserAccessForReviewingTool(): boolean {
        const userPrivileges = getUserPrivileges();
        return userPrivileges && userPrivileges.includes('system_role_testextendedcontentadmin_rel');
    },
    hasAccessForAuthorOrExtendedaccess(): boolean {
        const userPrivileges = getSessionPrivileges();
        return userPrivileges?.includes('system_role_testextendedcontentadmin_rel') || userPrivileges?.includes('system_role_testauthor_rel');
    },
    hasAccessForAuthorRole(): boolean {
        const userPrivileges = getSessionPrivileges();
        return Boolean(userPrivileges?.includes('system_role_testauthor_rel'));
    },
    hasCurrentUserAccessForAuthorTool(): boolean {
        const userPrivileges = getUserPrivileges();
        if (!userPrivileges) return false;

        const isBlocklistAdminPermission = getBlocklistAdminPermission() && userPrivileges.includes('system_role_testusersadmin_rel');

        return userPrivileges.includes('system_role_testauthor_rel')
            || isBlocklistAdminPermission
            || hasExitLockdownPermission();
    },
    filterColumnsByPermissions: (columns: any[], dataType?: string, featureId?: string): any[] => {
        const userPrivileges = getUserPrivileges();
        const searchDefinitions: SearchColumn[] = searchQueryBuilderService.getColumnsDefinition(dataType, featureId);
        return columns.filter((column: any) => {
            const searchDef: SearchColumn = searchDefinitions.find((def: SearchColumn) => column.name === def.ref
                || column.name === def.name
                || column.ref === def.ref
                || column.ref === def.name);

            if (column.ref === 'selection') return true;

            if (searchDef) {
                if (isNullOrUndefined(searchDef.privilege)) {
                    return true;
                }
                if (searchDef.internal) {
                    return false;
                }
                return searchDef.privilege.some((priv: UserPrivileges) => userPrivileges.indexOf(priv) > -1);
            }
            return false;
        });
    },
};

export default permissionService;
